<template>
  <fragment>
    <QuotationListGarantia v-if="userAreaIsGarantia" />
    <QuotationListAgro v-if="userAreaIsAgro" />
  </fragment>
</template>
<script>
import { mapActions, mapState } from "vuex";
import QuotationListGarantia from "./QuotationListGarantia";
import QuotationListAgro from "./QuotationListAgro";

export default {
  components: {
    QuotationListGarantia,
    QuotationListAgro
  },
  computed: {
    ...mapState("me", ["userAreaIsGarantia", "userAreaIsAgro"])
  },
  created() {
    if (!this.userAreaIsGarantia && !this.userAreaIsAgro) {
      this.requestMyInfo();
    }
  },
  methods: {
    ...mapActions("me", ["requestMyInfo"])
  }
};
</script>